module.exports = __webpack_public_path__ + "assets/img/thankBanner.d0096c9f.png";